export const SingleStepBody = ({ content }: any) => {
  return (
    <div className="flex-container flex-column align-start width-100 height-100">
      {content}
    </div>
  );
};
